import type { Currency, Plan, PlanView } from "../plans";

export type LandingData = {
  plans: PlanView[];
  currency: Currency | null; // null for logged-out visitors (prices hidden, savings still shown)
  loggedIn: boolean;
  proDaysLeft: number | null; // set when the user already has an active subscription
  strings: { title: string; description: string };
};

// Where every buy button goes. /subscribe asks logged-out visitors to log in and returns them here.
export const checkoutHref = (plan?: Plan) => (plan ? `/subscribe?plan=${plan}` : "/subscribe");

export const INSTAGRAM_URL = "https://instagram.com/fonta.fa";
